/**
 * For React Native, the caller is responsible for providing VisitorId/RoutePath etc. to logger context
 */
export const loggerContext = {};
